import { SurveyRatingElementOptions } from '@/models/survey-elements/rating-options';
import { TextareaFieldProps } from '@/models/widgets/props/textarea-field';
import { Expose, Type } from 'class-transformer';

export class Rating5StarProps {
  @Expose()
  title?: string;

  @Expose()
  options!: SurveyRatingElementOptions[];

  @Expose()
  isSubmitable?: boolean;

  @Expose()
  value!: SurveyRatingElementOptions | null;

  @Expose()
  @Type(() => TextareaFieldProps)
  additionalTextAreaElements!: TextareaFieldProps[] | null;

  @Expose()
  externalApiIdentifier!: string | null;
}
